import { useEffect, useRef, useState } from "react";

import ModelForPrintingCaseDetailsSectionLegacy from "./ModelForPrintingCaseDetailsSection";

const getResolvedMissingTeethFlag = (orderCaseData) => {
  if (orderCaseData?.missingTeethSelectedTeeth?.length > 0) {
    return "Yes";
  }

  if (orderCaseData?.hasMissingTeeth !== undefined && orderCaseData?.hasMissingTeeth !== null) {
    if (orderCaseData?.hasMissingTeeth === true || orderCaseData?.hasMissingTeeth === "Yes") {
      return "Yes";
    }
    if (orderCaseData?.hasMissingTeeth === false || orderCaseData?.hasMissingTeeth === "No") {
      return "No";
    }
  }

  return "";
};

export const ModelForPrintingCaseDetailsSectionV2 = (props) => {
  const [hydratedOrderCaseData, setHydratedOrderCaseData] = useState(null);
  const hasHydratedDraftRef = useRef(false);
  const hydratedOrderIdRef = useRef(null);

  useEffect(() => {
    if (hydratedOrderIdRef.current !== props?.orderObjId) {
      hydratedOrderIdRef.current = props?.orderObjId || null;
      hasHydratedDraftRef.current = false;
      setHydratedOrderCaseData(null);
    }

    if (hasHydratedDraftRef.current) {
      return;
    }

    const hasIncomingDraft =
      (props?.orderCaseData?.services?.length || 0) > 0 ||
      (props?.orderCaseData?.missingTeethSelectedTeeth?.length || 0) > 0 ||
      props?.orderCaseData?.numberSystem !== undefined ||
      props?.orderCaseData?.hasMissingTeeth !== undefined;

    if (!hasIncomingDraft) {
      return;
    }

    const normalized = {
      ...(props?.orderCaseData ?? {}),
      hasMissingTeeth: getResolvedMissingTeethFlag(props?.orderCaseData),
      missingTeethSelectedTeeth:
        props?.orderCaseData?.missingTeethSelectedTeeth ||
        (props?.orderCaseData?.missingTeeth || [])?.reduce((acc, item) => {
          if (item?.expiryDate === null || item?.expiryDate === undefined) {
            acc.push(item?.teethno);
          }
          return acc;
        }, []),
    };

    setHydratedOrderCaseData(normalized);
    hasHydratedDraftRef.current = true;
  }, [props?.orderCaseData, props?.orderObjId]);

  const normalizedOrderCaseData = hydratedOrderCaseData || {
    ...(props?.orderCaseData ?? {}),
    hasMissingTeeth: getResolvedMissingTeethFlag(props?.orderCaseData),
    missingTeethSelectedTeeth:
      props?.orderCaseData?.missingTeethSelectedTeeth ||
      (props?.orderCaseData?.missingTeeth || [])?.reduce((acc, item) => {
        if (item?.expiryDate === null || item?.expiryDate === undefined) {
          acc.push(item?.teethno);
        }
        return acc;
      }, []),
  };

  return (
    <ModelForPrintingCaseDetailsSectionLegacy
      {...props}
      orderCaseData={normalizedOrderCaseData}
    />
  );
};

export default ModelForPrintingCaseDetailsSectionV2;
